import getErrorMessage from './getErrorMessage';
export const isLoadingSelector = (reducerName) => (state) => state[reducerName].isLoading;
export const errorSelector = (reducerName) => (state) => {
    return {
        error: state[reducerName].error,
        errorMessage: getErrorMessage(state[reducerName].errorMessage),
        originalMessage: state[reducerName].errorMessage
    };
};
export const isUpdatedSelector = (reducerName) => (state) => state[reducerName].isUpdated;
//# sourceMappingURL=helperSelectors.js.map